import { useEffect } from "react";
import WestDesMoinesHeroSection from "./components/HeroSection";
import WestDesMoinesStickyNav from "./components/StickyNav";
import WestDesMoinesProcessingTimeSection from "./components/ProcessingTimeSection";
import WestDesMoinesServicesSection from "./components/ServicesSection";
import WestDesMoinesLocalAreaSection from "./components/LocalAreaSection";
import WestDesMoinesTestimonialsSection from "./components/TestimonialsSection";
import WestDesMoinesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WestDesMoinesComparisonSection from "./components/ComparisonSection";
import WestDesMoinesMistakesSection from "./components/MistakesSection";
import WestDesMoinesHowItWorksSection from "./components/HowItWorksSection";
import WestDesMoinesFAQSection, { faqs } from "./components/FAQSection";
import WestDesMoinesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WestDesMoinesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function WestDesMoinesPage() {
  useEffect(() => {
    document.title = "Emergency Passport West Des Moines IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/west-des-moines/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in West Des Moines, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Jordan Creek corporate travelers, insurance professionals, and Dallas County families.");
    setMeta("geo.placename", "West Des Moines, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "41.5772;-93.7592");
    setMeta("ICBM", "41.5772, -93.7592");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "West Des Moines Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for West Des Moines, Jordan Creek corporate travelers, and the Des Moines metro. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "West Des Moines", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <WestDesMoinesHeroSection />
      <WestDesMoinesStickyNav />
      <WestDesMoinesProcessingTimeSection />
      <WestDesMoinesServicesSection />
      <WestDesMoinesLocalAreaSection />
      <WestDesMoinesTestimonialsSection />
      <WestDesMoinesAcceptanceFacilitiesSection />
      <WestDesMoinesComparisonSection />
      <WestDesMoinesMistakesSection />
      <WestDesMoinesHowItWorksSection />
      <WestDesMoinesFAQSection />
      <WestDesMoinesHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/west-des-moines" state="IA" />
      <WestDesMoinesFinalCTA />
    </div>
  );
}